import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import './DreamVacationCard.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PlanYourJourneyModal from '../../../DynamicDestination/PlanYourJourneyModal';

const DreamVacationCard = ({ packageDetails }) => {
  const { country, countrysite, state, slug } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const [isJourneyModalOpen, setIsJourneyModalOpen] = useState(false);
  const isDestinationRoute = location.pathname.startsWith('/destination/');
  const buttonText = isDestinationRoute ? 'Plan Your Journey' : 'Enquire Now';

  const handleEnquiryNow = () => {
    if (isDestinationRoute) {
      setIsJourneyModalOpen(true);
      return;
    }

    const countryName =
      packageDetails?.country === 'India' ? packageDetails?.state : packageDetails?.country;
    const packageId = packageDetails?.new_item_code;

    sessionStorage.setItem(
      'tripDetails',
      JSON.stringify({
        countryName: countryName,
        packageId: packageId
      })
    );

    if (!packageId) {
      console.error('Missing packageId');
      return;
    }

    if (slug) {
      navigate(`/destination/${slug}/${packageId}/vacation-spot#month-travelling`, {
        state: {
          packageId: packageId,
          selectedTour: countryName,
          returnTo: `${location.pathname}${location.search}`
        }
      });
      return;
    }

    if (!country || !countrysite || !state) {
      console.error('Missing params:', { country, countrysite, state, packageId });
      return;
    }

    navigate(
      `/explore/${country}/${countrysite}/${state}/${packageId}/vacation-spot#month-travelling`,
      {
        state: {
          packageId: packageId,
          selectedTour: countryName,
          returnTo: `${location.pathname}${location.search}`
        }
      }
    );
  };

  return (
    <Box className="dream-vacation-card">
      <Box className="title">Dream Vacation : 3 Steps away !</Box>
      <Box className="steps">
        <ul>
          <li>
            <Box className="number">01</Box>
            <Box className="subtitle">Describe your dream Trip</Box>
          </li>
          <li>
            <Box className="number">02</Box>
            <Box className="subtitle">
              Tell us your Requirements & we will get back to you with the customizations
            </Box>
          </li>
          <li>
            <Box className="number">03</Box>
            <Box className="subtitle">Book the Trip</Box>
          </li>
        </ul>
      </Box>
      <Box className="btn-container">
        <Button className="customize-tour-btn" variant="contained" onClick={handleEnquiryNow}>
          {buttonText}
        </Button>
      </Box>

      {isDestinationRoute && (
        <PlanYourJourneyModal
          open={isJourneyModalOpen}
          onClose={() => setIsJourneyModalOpen(false)}
          tourPackage={packageDetails}
        />
      )}
    </Box>
  );
};

export default DreamVacationCard;
